import AgreementViewerScreen from 'features/PdfViewerScreen/PdfViewerScreen';
import React from 'react';

export default function AgreementViewer() {
  return <AgreementViewerScreen />;
}
